import { isExpiredAuthBody, refreshExpiredYourAiSession } from '@/core/apis/yourai/sseAuthRefresh';
import { getClientSessionData } from '@/core/utils/auth-utils';

interface FetchDspyOptions {
  /** Used as the bearer when the client session has no JWT. The ask hook is
   *  given a token directly via props; the analyse hook never sets this. */
  fallbackToken?: string;
}

/** Fetch wrapper used by every cognition SSE hook against the dspy-promptor
 *  service. Attaches the current JWT and transparently retries once after a
 *  401 caused by an expired token. */
export async function fetchDspyWithAuthRefresh(
  url: string,
  init: RequestInit = {},
  { fallbackToken }: FetchDspyOptions = {},
): Promise<Response> {
  const doFetch = async (): Promise<Response> => {
    const session = await getClientSessionData();
    const jwt = session?.jwt || fallbackToken;
    return fetch(url, {
      ...init,
      headers: {
        ...(init.headers as Record<string, string>),
        ...(jwt ? { Authorization: `Bearer ${jwt}` } : {}),
      },
    });
  };

  let response = await doFetch();
  if (response.status === 401) {
    const body = await response
      .clone()
      .text()
      .catch(() => '');
    if (isExpiredAuthBody(body)) {
      const refreshed = await refreshExpiredYourAiSession();
      if (refreshed) {
        response = await doFetch();
      }
    }
  }
  return response;
}
